import { sendHTTPRequest } from '@/util/http.ts'

const toolkitUrl = import.meta.env.VITE_TOOLKIT_URL

/** The fields of a shared student's drafted statement that the shared page reads; the endpoint returns more. */
export type SharedStudentStatement = {
  student: {
    student_name: string
    student_uuid: string
    enrolled_grade_level: string
    selected_subjects: string[]
    drafted_strengths: string
    updated_at: string
  }
  user?: { name?: string }
}

export async function getSharedStudentStatement(uuid: string): Promise<SharedStudentStatement> {
  try {
    const response = await sendHTTPRequest({
      url: `${toolkitUrl}/api/library/shared/presentlevels/${uuid}`,
      method: 'GET',
      includeCredentials: false
    })
    return await response.json() as SharedStudentStatement
  } catch (e) {
    throw new Error('Failed to get shared present levels statement', { cause: e })
  }
}
